<div class="listagem-obras">
  <div class="toolbar toolbar--horizontal" *ngIf="exibirCabecalho || mostrarApenasItensPagina">
    <ng-container *ngIf="!mostrarApenasItensPagina; else apenasItensPagina">
      <div>
        <h2 class="toolbar__title">
          {{ title }} <span>{{ subtitle }}</span>
        </h2>
        <p *ngIf="descriptionSubtitle" class="toolbar__description">{{ descriptionSubtitle }}</p>
      </div>
    </ng-container>

          <div class="acoes-wrapper" *ngIf="!mostrarApenasItensPagina">
        <button
          class="btn-exportar"
          type="button"
          (click)="onDownloadPdf()"
          [disabled]="!temAcessoModulo && !podeEditarAcao"
          [class.disabled]="!temAcessoModulo && !podeEditarAcao"
          title="Exportar PDF"
        >
       
          <img
            src="{{
              BASE_IMG_URL
            }}assets/filtro-lateral-busca/icone-pdf.webp"
            alt="pdf"
          />
        </button>
        <button
          class="btn-exportar"
          type="button"
          (click)="onImprimir()"
          [disabled]="!temAcessoModulo && !podeEditarAcao"
          [class.disabled]="!temAcessoModulo && !podeEditarAcao"
          title="Imprimir ficha da obra"
        >
    
          <img
            src="{{
              BASE_IMG_URL
            }}assets/filtro-lateral-busca/icone-imprimir.webp"
            alt="print"
          />
        </button>
      </div>

  </div>

  <div class="filtros-container" *ngIf="!mostrarApenasItensPagina && exibirFiltros">
    <div class="filtros-linha-1">
        <div class="search-filter-wrapper">
        <div class="search-filter-inline">
          <select
            [(ngModel)]="searchType"
            (ngModelChange)="onSearchTypeChange($event)"
            class="search-select-inline"
          >
            <option value="obra">busca por id/obra</option>
            <option value="empresa">busca por empresa</option>
          </select>

          <div class="input-container-inline">
            <img
              src="{{ BASE_IMG_URL }}assets/header/icon-search-label.png"
              alt=""
              class="input-icon-inline"
            />
            <input
              type="text"
              class="search-input-inline"
              [ngModel]="searchTerm"
              (ngModelChange)="onSearchTermChange($event)"
              (keyup.enter)="onSearchEnter()"
              maxlength="200"
              placeholder="Enter para buscar..."
            />
            <button
              type="button"
              class="clear-search-btn"
              *ngIf="searchTerm"
              (click)="clearSearch()"
              aria-label="Limpar busca"
            >
              ×
            </button>
          </div>
        </div>
      </div>

      <div class="filtro-tipo-obra-wrapper">
        <app-filtro-tipo-obra
          [tiposObra]="tiposObra"
          [filtroTipoObraSelecionados]="filtroTipoObraSelecionados"
          (tiposSelecionadosChange)="onTiposObraSelecionadosChange($event)"
        ></app-filtro-tipo-obra>
      </div>

      <div class="filtro-responsavel-wrapper">
        <app-filtro-responsavel
          *ngIf="showFiltroResponsavel"
          [responsavel]="responsavel"
          [filtroResponsavel]="filtroResponsavel"
          (filtroResponsavelChange)="onFiltroResponsavelChange($event)"
          (responsavelIdChange)="onResponsavelIdChange($event)"
          (responsavelLimpo)="onResponsavelLimpo()"
        ></app-filtro-responsavel>
        </div>

      <div class="filtro-periodo-wrapper">
        <div class="button-group-toggle">
          <button
            type="button"
            class="toggle-btn"
            [class.active]="updateInterval === 7"
            (click)="onUpdateIntervalChange(7)"
            title="Obras da carteira que tiveram atualização nos últimos 7 dias"
          >
            7 dias
          </button>
          <button
            type="button"
            class="toggle-btn"
            [class.active]="updateInterval === 15"
            (click)="onUpdateIntervalChange(15)"
            title="Obras da carteira que tiveram atualização nos últimos 15 dias"
          >
            15 dias
          </button>
          <button
            type="button"
            class="toggle-btn"
            [class.active]="updateInterval === 30"
            (click)="onUpdateIntervalChange(30)"
            title="Obras da carteira que tiveram atualização nos últimos 30 dias"
          >
            30 dias
          </button>
        </div>
      </div>
      </div>

      <div class="filtros-linha-2">
      <div class="itens-pagina-wrapper">
        <div class="itens-pagina">
          <select
            class="pagination-select"
            [(ngModel)]="pageSize"
            (ngModelChange)="pageSizeChange.emit($event)"
>
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              Visualizar {{ size }} obras
            </option>
          </select>
        </div>
      </div>


      <div
        class="pagination-container pagination-top"
        *ngIf="totalItems > pageSize && (temAcessoModulo || podeEditarAcao)"
      >
        <span>
          <b>{{ (page - 1) * pageSize + 1 }}</b> -
          <b>{{ min(page * pageSize, totalItems) }}</b> de
          <b>{{ totalItems }}</b>
        </span>
        <button
          type="button"
          class="pagination-button-top"
          (click)="mudarPagina(-1)"
          [disabled]="page === 1"
          title="Página anterior"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/filtro-lateral-busca/arrow_circle_left.svg"
            alt="Anterior"
          />
        </button>
        <button
          type="button"
          class="pagination-button-top"
          (click)="mudarPagina(1)"
          [disabled]="page === totalItems"
          title="Próxima página"
        >
          <img
            src="{{
              BASE_IMG_URL
            }}assets/filtro-lateral-busca/arrow_circle_right.svg"
            alt="Próximo"
          />
        </button>
      </div>
      </div>
  </div>

    <ng-container *ngIf="!mostrarApenasItensPagina">
    </ng-container>
    <ng-template #apenasItensPagina>
      <div class="bloco-resultado-filtro">
        <div class="btn-acoes">
          <app-bnt-imprimir
            [icon]="
              BASE_IMG_URL +
              'assets/filtro-lateral-busca/icone-imprimir.webp'
            "
            (click)="onImprimir()"
            [disabled]="!temAcessoModulo && !podeEditarAcao"
            [esmaecido]="!selectedRows.length"
          ></app-bnt-imprimir>
          <app-btn-exportar-pdf
            [icon]="
              BASE_IMG_URL +
              'assets/filtro-lateral-busca/icone-pdf.webp'
            "
            (click)="onDownloadPdf()"
            [disabled]="!temAcessoModulo && !podeEditarAcao"
            [esmaecido]="!selectedRows.length"
          ></app-btn-exportar-pdf>
          <app-btn-exportar-excel
            [icon]="
              BASE_IMG_URL +
              'assets/filtro-lateral-busca/icone-excel.webp'
            "
            (click)="onExportarExcel()"
            [disabled]="!temAcessoModulo && !podeEditarAcao"
            [esmaecido]="!selectedRows.length"
          ></app-btn-exportar-excel>
        </div>

        <div class="toolbar__right toolbar__right--inline">
          <div class="itens-pagina">
            <select
              class="pagination-select"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageSizeChange.emit($event)"
              [disabled]="!temAcessoModulo && !podeEditarAcao"
              [class.disabled]="!temAcessoModulo && !podeEditarAcao"
            >
              <option *ngFor="let size of pageSizeOptions" [value]="size">
                Visualizar {{ size }} obras
              </option>
            </select>
          </div>

          <div
            class="pagination-container pagination-top"
            *ngIf="totalItems > pageSize && (temAcessoModulo || podeEditarAcao)"
          >
            <span>
              <b>{{ (page - 1) * pageSize + 1 }}</b> -
              <b>{{ min(page * pageSize, totalItems) }}</b> de
              <b>{{ totalItems }}</b>
            </span>
            <button
              type="button"
              class="pagination-button-top"
              (click)="mudarPagina(-1)"
              [disabled]="page === 1"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/filtro-lateral-busca/arrow_circle_left.svg"
                alt="Anterior"
                width="24"
                height="24"
              />
            </button>
            <button
              type="button"
              class="pagination-button-top"
              (click)="mudarPagina(1)"
              [disabled]="page === totalItems"
            >
              <img
                src="{{
                  BASE_IMG_URL
                }}assets/filtro-lateral-busca/arrow_circle_right.svg"
                alt="Próximo"
                width="24"
                height="24"
              />
            </button>
          </div>
        </div>
      </div>
    </ng-template>

  <table class="table container-fluid">
    <thead class="title-table">
      <tr>
        <th>
          <input
            type="checkbox"
            class="checkbox"
            [checked]="selectAllChecked"
            (change)="toggleSelectAll($event)"
            [disabled]="!temAcessoModulo && !podeEditarAcao"
            [class.disabled]="!temAcessoModulo && !podeEditarAcao"
          />
        </th>
        <th
          *ngFor="let col of columns"
          [attr.title]="col.tooltip"
          [class.sortable]="col.sortable && col.key !== 'id'"
          (click)="
            col.sortable && col.key !== 'id' ? ordenarPor(col.key) : null
          "
          style="cursor: pointer; user-select: none"
        >
          <span>{{ col.label }}</span>
          <ng-container *ngIf="col.sortable && col.key !== 'id'">
            <img
              src="{{
                BASE_IMG_URL
              }}assets/agenda-tarefas/order.svg"
              alt="ordenar"
              class="img-order"
              width="16"
              height="16"
              [class.ativo]="colunaOrdenada === col.key"
              [style.filter]="
                colunaOrdenada === col.key ? 'brightness(0.5)' : 'none'
              "
            />
          </ng-container>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!loading">
      <tr *ngFor="let row of data">
        <td>
          <input
            type="checkbox"
            class="checkbox"
            [checked]="selectedRows.includes(row)"
            (change)="toggleRow(row, getChecked($event))"
            [disabled]="!temAcessoModulo && !podeEditarAcao"
            [class.disabled]="!temAcessoModulo && !podeEditarAcao"
          />
        </td>
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.type">
            <span *ngSwitchCase="'tag'">
              <ng-container *ngIf="col.key === 'modulos'; else noTag">
                <span class="tag" [ngClass]="getTagClass(row[col.key])">{{
                  row[col.key]
                }}</span>
              </ng-container>
              <ng-template #noTag>
                {{ row[col.key] }}
              </ng-template>
            </span>
            <span *ngSwitchDefault>
              <ng-container *ngIf="col.key === 'obra'; else otherColumns">
                <a
                  href="#"
                  (click)="$event.preventDefault(); onObraClick(row)"
                  [attr.title]="row[col.key]"
                  >{{
                    row[col.key]?.length > 32
                      ? (row[col.key] | slice : 0 : 32) + "..."
                      : row[col.key]
                  }}</a
                >
              </ng-container>

              <ng-template #otherColumns>
                <ng-container *ngIf="col.key === 'empresa'; else genericCell">
                  <a
                    href="#"
                    (click)="$event.preventDefault(); onEmpresaClick(row)"
                    [attr.title]="row.companyName || row.empresa || row.name"
                  >
                    {{
                      (row.companyName || row.empresa || row.name)?.length > 32
                        ? (row.companyName || row.empresa || row.name
                            | slice : 0 : 32) + "..."
                        : row.companyName || row.empresa || row.name
                    }}
                  </a>
                </ng-container>
                <ng-template #genericCell>
                  <span [attr.title]="row[col.key]">
                    {{ row[col.key] }}
                  </span>
                </ng-template>
              </ng-template>
            </span>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="no-results-container" *ngIf="data.length === 0 && !loading">
    <div class="no-results">
      <p>Nenhum resultado encontrado!</p>
    </div>
  </div>

  <div
    class="pagination-container"
    *ngIf="totalItems > pageSize && (temAcessoModulo || podeEditarAcao)"
  >
    <button
      type="button"
      class="pagination-button"
      (click)="mudarPagina(-1)"
      [disabled]="page === 1"
    >
      Anterior
    </button>

    <ng-container *ngFor="let p of visiblePages">
      <button
        type="button"
        class="pagination-number"
        [ngClass]="{ active: page === p }"
        (click)="goToPage(p)"
      >
        {{ p }}
      </button>
    </ng-container>

    <button
      type="button"
      class="pagination-button"
      (click)="mudarPagina(1)"
      [disabled]="page === totalItems / pageSize"
    >
      Próximo
    </button>
  </div>
  </div>